// PinExpiry — quietly unpin a widget once its match kicks off (Ben, Q-006).
//
// A pin keeps a bet's data live until the match starts; after that there's
// nothing left to bet on, so the widget follows the top bar like the rest. No
// note or message ("a returning user's first moment shouldn't be a negative
// one"). A board load already drops kicked-off pins (store `setModules`); this
// catches a match that kicks off while the page is open. Once a minute is
// plenty: kick-offs are on the minute and nothing is bet on in that minute.
//
// Renders nothing. Mounted once at the app root.

import { useEffect } from "react";
import { useBentoStore } from "../store/index.js";

export const PIN_CHECK_MS = 60_000;

export default function PinExpiry() {
  useEffect(() => {
    const check = () => useBentoStore.getState().unpinKickedOff();
    check();
    const timer = window.setInterval(check, PIN_CHECK_MS);
    return () => window.clearInterval(timer);
  }, []);
  return null;
}
